// extracted by mini-css-extract-plugin
module.exports = {"HoverEffect":"Navbar_HoverEffect__7iNPg","MyActive":"Navbar_MyActive__2Ng--"};